import { render, staticRenderFns } from "./BaseSelect.vue?vue&type=template&id=1183f2b0&scoped=true&"
import script from "./BaseSelect.vue?vue&type=script&lang=js&"
export * from "./BaseSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelect.vue?vue&type=style&index=0&id=1183f2b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1183f2b0",
  null
  
)

export default component.exports